define('lq/events/actions/rawSqlCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function RawSql(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(RawSql, EventAction);

    RawSql.typeName = 'RawSql';

    RawSql.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    RawSql.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'RawSql',
            command: this.eventData.command
        };
    };

    return RawSql;
});

